import React from 'react';
import { Typography } from 'antd';
import * as Icons from '@ant-design/icons';
import { MinusCircleOutlined } from '@ant-design/icons';
import './PitstopBadge.css';

interface PitstopBadgeProps {
  text: string;
  icon: string;
  color: string;
}

/**
 * @param props
 * @param props.text - The text to display
 * @param props.icon - The icon to display
 * @param props.color - The color of the badge
 */
const PitstopBadge: React.FC<PitstopBadgeProps> = ({ text, icon, color }) => {
  const DynamicIcon =
    (Icons as any)[`${icon.charAt(0).toUpperCase()}${icon.slice(1)}Outlined`] ||
    MinusCircleOutlined;

  return (
    <div className="badge" style={{ borderColor: color }}>
      <DynamicIcon style={{ color, fontSize: '16px', marginRight: '4px' }} />
      <Typography.Text style={{ color }}>{text}</Typography.Text>
    </div>
  );
};

export default PitstopBadge;
